import { i18n } from '@fs/zion-locale'

export const accountHeadingString = () => i18n.t('account.heading', 'Account')

export const churchRecordNumberFieldString = () => i18n.t('church-record-number.label', 'Church Record Number')

export const continueString = () => i18n.t('common-ui:continue.action', 'Continue')

export const dataSharedPublicLabel = () => i18n.t('data-shared-public.label', 'Public')

export const dataSharedPrivateLabel = () => i18n.t('data-shared-private.label', 'Private')

export const emailFieldString = () => i18n.t('common-ui:email.address.abbr', 'Email')

export const emailOrPhoneRequiredString = () =>
  i18n.t('email-or-mobile-phone-required.validation', 'Either an email or mobile phone number is required.')

export const enableString = () => i18n.t('enable.action', 'Enable')

export const firstNamesFieldString = () => i18n.t('first-names.label', 'First Names')

export const lastNamesFieldString = () => i18n.t('last-names.label', 'Last Names')

export const notificationsDiscoveriesLabel = () =>
  i18n.t('notifications.discoveries-news-tips.label', 'Discoveries, News and Tips')

export const invalidFieldString = (fieldName) =>
  i18n.t('invalid-field.validation', 'Invalid {fieldName}', { fieldName })

export const restoreActionString = () => i18n.t('restore.action', 'Restore')

export const signInString = () => i18n.t('common-ui:sign-in.action', 'Sign In')

export const signOutString = () => i18n.t('sign-out.action', 'Sign Out')

export const textMessageRatesApplyString = () => i18n.t('text-message-rates-apply', 'Message and data rates may apply.')

export const usernameFieldString = () => i18n.t('common-ui:username.label', 'Username')
